import useEmblaCarousel from 'embla-carousel-react';
import { useSelector } from 'react-redux';
import ImageLoader from '../ImageLoader';
import { isEmptyData } from '../../utils/helper';
import { useMemo, useState } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import GroupDetail from './Detail/Index';

const Group = () => {
	const { list: categories = [] } = useSelector((state) => state.category);
	const [selected, setSelected] = useState(null);
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const [emblaRef] = useEmblaCarousel({
		align: 'start',
		dragFree: true,
		containScroll: 'trimSnaps',
	});

	const itemsToRender = useMemo(() => {
		if (isEmptyData(categories)) return [];

		return categories?.filter((c) => c?.type?.toUpperCase() === 'HIGHLIGHT');
	}, [categories]);

	const handleSelect = (item) => {
		setSelected(item);
		setIsShowBottomSheet(true);
	};

	const handleCloseBottomSheet = () => {
		setSelected(null);
		setIsShowBottomSheet(false);
	};

	const groupDetailProps = {
		...selected,
		onClose: handleCloseBottomSheet,
	};

	return (
		<>
			<div className={`w-full max-w-md mx-auto mb-4.5 ${isEmptyData(itemsToRender) && 'hidden'}`}>
				<div className='overflow-hidden' ref={emblaRef} style={{ touchAction: 'pan-y' }}>
					<div className='flex gap-5 px-4'>
						{itemsToRender?.map((item, index) => (
							<div key={index} className='flex-none w-24 cursor-pointer' onClick={() => handleSelect(item)}>
								<div className={'relative mb-1.5 mt-2 rounded-xl transition-all'}>
									<ImageLoader src={item?.image} className='w-24 h-24 rounded-xl object-cover object-center' />
								</div>
								<p className='line-clamp-2 text-center text-xs text-gray-600 font-bold'>{item?.name}</p>
							</div>
						))}
					</div>
				</div>
			</div>
			<BottomSheet key={'group-detail'} open={isShowBottomSheet} onDismiss={handleCloseBottomSheet} header={false}>
				<GroupDetail {...groupDetailProps} />
			</BottomSheet>
		</>
	);
};

export default Group;
